import React, {useEffect, useState} from "react";
import TopBoxV2 from "../common/TopBoxV2";
import {ShopInfo2PopupV2} from "./ShopInfo2PopupV2";
import PageNameV2 from "../common/PageNameV2";
import PageTitleV2 from "../common/PageTitleV2";
import ShopSelectBoxV2 from "../common/ShopSelectBoxV2";
import {ShopTapBoxV2} from "../common/ShopTapBoxV2";
import {useAdminShopInfo, useShopInfo2} from "../../../static/js/hock/shopHock";
import imgRemoveBtn from "../../../static/image/v2/imgRemoveBtn.png";
import {ChoiceMessagePopupV2} from "../popup/ChoiceMessagePopupV2";
import {subNavEvent} from "../../../static/js/service/commonService";

export default function ShopInfo2V2() {
  let [shopList, setShopList] = useState([]);
  let [shopId, setShopId] = useState();
  let [imageList, setImageList] = useState([]);
  let [approvalTpcd1, setApprovalTpcd1] = useState();

  useShopInfo2({setImageList}, shopId);
  useAdminShopInfo({setApprovalTpcd1}, shopId);

  useEffect(() => {
    subNavEvent("shopNav", "shop1");
  }, []);

  function imgRemove(e) {
    let dataset = e.target.dataset;
    let dataId = dataset.id;
    document.querySelector("#imgRemoveBtn2").setAttribute("data-id", dataId);
    document.querySelector("#imgRemoveBtn2").setAttribute("data-shop", shopId);
    document.querySelector("#imgRemove2Popup").classList.remove("hide");
  }

  function modiBtn(e) {
    let dataset = e.target.dataset;
    let dataId = dataset.id;
    document.querySelector("#shopLogoImg2").setAttribute("data-id", dataId);
    document.querySelector(".shopInfoModi2Popup").classList.remove("hide");
  }

  function newBtn() {
    if(imageList.length >= 3) {
      alert('최대 3개까지 등록 가능합니다');
      return false;
    } else {
      document.querySelector(".shopInfo2Popup").classList.remove("hide");
    }
  }

  let items = imageList.map((value, index) => {
    return (
      <tr key={index} className="imgBoxTr">
        <td>{index + 1}</td>
        <td>
          <div className="imgBox">
            <img src={value.imageUrl} alt="공지 이미지" />
            <button className="imgRemoveBtn">
              <img src={imgRemoveBtn} alt="이미지 삭제" data-id={value.id} onClick={(e) => imgRemove(e)} />
            </button>
          </div>
        </td>
        <td>
          <button className="modiBtn" data-id={value.id} onClick={(e) => modiBtn(e)}>
            이미지 재등록
          </button>
        </td>
      </tr>
    )
  })

  return (
    <main id="ShopInfo2V2" className="mainV2">
      <TopBoxV2 shopList={shopList} />
      <ShopInfo2PopupV2 shopId={shopId} />
      <ChoiceMessagePopupV2 id="imgRemove2Popup" title="" text="등록된 이미지를 삭제하시겠어요?" name="imgRemoveBtn2" type="shopInfo2" />

      <div className="container">
        <section id="shopSec1" className="containerInner">
          <PageNameV2 title1="상점 관리" title2="상점 정보 관리" />
          <div className="pageTitle mb-10 d-flex a-center j-between">
            <PageTitleV2 title="상점 정보 관리" countText="" count="" unit="" />
          </div>
          <div className="topMenu">
            <div id="shopSelectBox">
              <ShopSelectBoxV2 url="/v2/shopInfo2" setShopId={setShopId} setShopList={setShopList} />
              <ShopTapBoxV2 tap="tap2" shopId={shopId} />
            </div>
            {approvalTpcd1 === 4 &&
              <button id="shopModiBtn" className="commonBtn width90 ml-5" onClick={() => newBtn()}>
                신규 등록
              </button>
            }
          </div>
          <div className="shopInfoBox">
            <table className="shopImgTable">
              <thead>
              <tr>
                <th style={{width:"98px"}}>No</th>
                <th style={{width:"742px"}}>이미지</th>
                <th style={{width:"402px"}}>수정</th>
              </tr>
              </thead>
              <tbody>
              {items}
              </tbody>
            </table>
          </div>
        </section>
      </div>
    </main>
  )
}